import styled, { css } from 'styled-components'
import { HexToRgba } from 'utils/colors'

const DragDropActiveStyles = css`
  border: 1px dashed ${(p) => p.theme.colors.blue1};
  border-radius: 3px;
  background-color: ${(p) => HexToRgba(p.theme.colors.blue7, 0.1)};

  & svg {
    color: ${(p) => p.theme.colors.blue1};
    opacity: 0.8;
  }

  & button {
    background-color: ${(p) => HexToRgba(p.theme.colors.gray5, 0.24)};
    color: ${(p) => p.theme.colors.gray5};
    border-radius: 4px;
  }
`

export const DragDropContainer = styled.div<{
  width?: string
  height?: string
  backgroundColor?: string
  isDragActive?: boolean
}>`
  width: ${(p) => p.width || '100%'};
  height: ${(p) => p.height || '100%'};
  background-color: ${(p) => p.backgroundColor || 'transparent'};
  ${(p) => p.isDragActive && DragDropActiveStyles}
`

export const DefaultViewContainer = styled.div<{ width?: string; height?: string }>`
  width: ${(p) => p.width || '100%'};
  height: ${(p) => p.height || '100%'};
  border: 1px dashed ${(p) => p.theme.colors.gray12};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DefaultViewContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DefaultViewContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  justify-content: center;
  align-items: center;

  button {
    margin-top: 10px;
  }
`
